'use client';

import clsx from 'clsx';
import DemoVideoList from './demo-video-list';
import DemoVideoWall from './demo-video-wall';
import { useLocale } from '@/components/providers/context/locale-context';
import { useTranslation } from 'react-i18next';
import { JSection } from '@/components/ui/layout';

export default function DemoVideo() {
    const locale = useLocale();
    const { t } = useTranslation('terra1-demo-video');

    const contentList: string[] = t('content', {
        returnObjects: true,
    }) as string[];

    return (
        <JSection
            spacing="none"
            size="lg"
            padding="none"
            className="mt-[80px] flex justify-center sm:mt-[160px]"
        >
            <div className="flex w-full flex-col items-center justify-center">
                <h3 className="hidden">{contentList[1]}</h3>
                <div
                    className={clsx(
                        'j-h5 w-full px-[28px] text-left text-white sm:w-[90%] sm:text-center',
                    )}
                >
                    {contentList.map((content, index) => {
                        const key = `content-${index}`;
                        return <span key={key}>{content}</span>;
                    })}
                </div>

                {/* <DemoVideoList locale={locale} /> */}

                <DemoVideoWall locale={locale} />
            </div>
        </JSection>
    );
}
